import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { DelayCategory } from "../models/CatalogCategory";

type getCatalogCategoriesProps = {
  includeInactives: boolean;
  delayAreaAssetId?: number | null;
  includeAncestor?: boolean;
  signal?: AbortSignal;
};

export const getCatalogCategories = async ({
  includeInactives,
  delayAreaAssetId,
  includeAncestor,
  signal,
}: getCatalogCategoriesProps) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "IncludeInactive", value: includeInactives },
  ];

  if (delayAreaAssetId)
    parameters.push({ name: "DelayAreaAssetId", value: delayAreaAssetId });

  if (includeAncestor)
    parameters.push({ name: "IncludeAncestor", value: includeAncestor });

  return await apiService.callV2(
    "[DEL].[GetDelayCategories]",
    parameters,
    signal,
  );
};

export const deleteCatalogCategory = async (DelayCategoryId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [];

  parameters.push({ name: "DelayCategoryId", value: DelayCategoryId });
  return await apiService.callV2("[DEL].[DeleteDelayCategory]", parameters);
};

export const upsertCatalogCategory = async (category: DelayCategory) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [];

  parameters.push({ name: "DelayCategoryId", value: category.DelayCategoryId });
  parameters.push({
    name: "DelayAreaAssetId",
    value: category.AssetId,
  });
  parameters.push({
    name: "DelayCategoryName",
    value: category.DelayCategoryName,
  });
  parameters.push({
    name: "DelayCategoryColor",
    value: category.DelayCategoryColor,
  });
  parameters.push({ name: "IsActive", value: category.IsActive });

  return await apiService.callV2("[DEL].[UpsertDelayCategory]", parameters);
};
